import { ComponentType, lazy, LazyExoticComponent } from 'react'

/**
 * Wraps React.lazy() to handle modules that use named exports rather than
 * default exports. Webpack splits the import() into its own chunk; the
 * helper drops the boilerplate of `.then(m => ({ default: m.X }))`.
 *
 * Example:
 *   const SettingsPage = lazyNamed(() => import('./pages/SettingsPage'), 'SettingsPage')
 */
export function lazyNamed<K extends string>(
  loader: () => Promise<Record<K, ComponentType<unknown>>>,
  key: K,
): LazyExoticComponent<ComponentType<unknown>> {
  return lazy(() => loader().then(m => ({ default: m[key] })))
}
